import { Box, GlobalStyles, Typography } from '@mui/material';
import Loading from 'components/common/Loading';
import PDFPreviewLazy from 'components/common/PDFPreviewLazy';
import { any } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const DOC_CLASS = 'modals-pdf-phone-preview-doc';
const PAGE_CLASS = 'modals-pdf-phone-preview-page';

const pdfGlobalStyles = {
  [`.${DOC_CLASS}`]: {
    width: 189,
    height: 250,
    overflow: 'hidden',
  },
  [`.${PAGE_CLASS}`]: {
    padding: '10px',
    width: 189,
  },
};

const PdfPhonePreview = ({ src }) => (
  <>
    <GlobalStyles styles={pdfGlobalStyles} />
    <Box
      sx={{
        m: '6px',
        backgroundColor: '#f2f4f7',
        minWidth: '500px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Typography
        sx={{
          pt: '15px',
          pl: '15px',
          fontSize: 13,
          textTransform: 'uppercase',
          fontWeight: 500,
          color: 'secondary.main',
        }}
      >
        {I18n.t('AcknowledgementCreate.This is a message preview')}
      </Typography>
      <Box
        sx={{
          backgroundImage: 'url(/images/iPhone.png)',
          backgroundPosition: 'center 50px',
          backgroundSize: '220px 420px',
          backgroundRepeat: 'no-repeat',
          minHeight: '368px',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-end',
        }}
      >
        <Box
          sx={{
            width: 189,
            height: 267,
          }}
        >
          <PDFPreviewLazy
            file={src}
            docClassName={DOC_CLASS}
            loading={<Loading sx={{ mt: '20px' }} size={60} />}
            pageClassName={PAGE_CLASS}
            width={169}
          />
        </Box>
      </Box>
    </Box>
  </>
);

PdfPhonePreview.propTypes = {
  src: any.isRequired,
};

export default PdfPhonePreview;
